import { render, staticRenderFns } from "./DurationField.vue?vue&type=template&id=03d6de95&scoped=true&"
import script from "./DurationField.vue?vue&type=script&lang=js&"
export * from "./DurationField.vue?vue&type=script&lang=js&"
import style0 from "./DurationField.vue?vue&type=style&index=0&id=03d6de95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d6de95",
  null
  
)

export default component.exports